import { HTTPError, TimeoutError } from '@fingermarkglobal/request';
import ky from 'ky';

const loyaltyCreateRedemptions = async ({
  token,
  transactionId,
  payload,
  promoId,
  redemptions,
}: {
  token: string;
  transactionId: string;
  payload: any;
  promoId: string;
  redemptions: string[];
}) => {
  console.info('fm-api - loyaltyCreateRedemptions - started');
  try {
    if (!process.env.POI_APP_LOYALTY_SERVICE_ENDPOINT) {
      throw new Error(
        'fm-api - loyaltyCreateRedemptions - failed to get loyalty logout endpoint in the environment file with the key POI_APP_LOYALTY_SERVICE_ENDPOINT.',
      );
    }
    const endpoint = `${process.env.POI_APP_LOYALTY_SERVICE_ENDPOINT}/loyalty/integration/${transactionId}/redemptions/${promoId}/redeem`;
    const response = await ky.post(endpoint, {
      timeout: 30 * 1000,
      headers: { 'x-authorization-loyalty': `Bearer ${token}` },
      json: { cart: payload.cart, productIds: redemptions },
    });

    if (!response.ok) {
      throw new Error('fm-api - loyaltyCreateRedemptions - request failed. No response received');
    }

    console.info('fm-api - loyaltyCreateRedemptions - finished', response);

    const data = await response.json();
    return data;
  } catch (err) {
    if (err instanceof HTTPError || err instanceof TimeoutError) throw err;

    console.error('fm-api - loyaltyCreateRedemptions - error:', err);
    throw err;
  }
};

export { loyaltyCreateRedemptions };
